import images from './images';
import svgs from './svgs';

export const dashboardBanner = [
  {
    slug: 'kbc',
    name: 'kbc',
    image: images.DashboardBanner,
    layoutType: 'potrait',
    key: 'kbc1'
  },
  {
    slug: 'kbc',
    name: 'kbc',
    image: images.DashboardBanner,
    layoutType: 'potrait',
    key: 'kbc2'
  }
];

export const dashboardBannerMobile = [
  {
    slug: 'kbc',
    name: 'kbc',
    image: images.DashboardBannerMobile,
    layoutType: 'potrait',
    key: 'kbc1'
  },
  {
    slug: 'kbc',
    name: 'kbc',
    image: images.DashboardBannerMobile,
    layoutType: 'potrait',
    key: 'kbc2'
  }
];

export const homePageTabRoutes = [
  { key: 'New Games', title: 'New Games', icon: svgs.NewGames },
  { key: 'Recently Played', title: 'Recently Played', icon: svgs.NewGames },
  { key: 'Cards', title: 'Cards', icon: svgs.Cards },
  { key: 'Quiz', title: 'Quiz', icon: svgs.Quiz },
  { key: 'Sports', title: 'Sports', icon: svgs.Racing },
  { key: 'Arcade', title: 'Arcade', icon: svgs.Arcade },
  { key: 'Racing', title: 'Racing', icon: svgs.Racing },
  { key: 'Puzzles', title: 'Puzzles', icon: svgs.Puzzles },
  { key: 'Strategy', title: 'Strategy', icon: svgs.Puzzles }
];
